import { FC, useState } from 'react';
import { UserEditRequestViewProps } from './types';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { observer } from 'mobx-react-lite';
import { useStyles } from './styles';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, Modal, Paper, IconButton } from '@material-ui/core';
import { UserEditRequestForm } from '../UserEditRequestForm';
import { UserRejectRequestForm } from '../UserEditRequestForm/UserRejectRequestForm';

export const UserEditRequestView: FC<UserEditRequestViewProps> = observer(
  ({ open, refetch, handleClose, id, setId }) => {
    const classes = useStyles();
    const [openUserRequestModal, setOpenUserRequestModal] = useState<boolean>(false);
    const [openUserRejectRequestModal, setOpenUserRejectRequestModal] = useState<boolean>(false);

    const {
      userEditRequestTableStore: { getUserChange, acceptChange },
      notificationStore: { openNotification },
    } = useStore();
    const getUserChangeReq = useQuery('getUserChangeReq', () => getUserChange(id), {
      onError: (e) => {
        openNotification('error', `Can't get users request`);
      },
    });
    const acceptChangeReq = useMutation(({ id, status }: { id: number; status: string }) => acceptChange(id, status), {
      onSuccess: () => {
        openNotification('success', 'User Updated');
        refetch();
      },
      onError: (e) => {
        openNotification('error', `Can't accept changes`);
      },
    });
    useAppPreloader(getUserChangeReq.isFetching || acceptChangeReq.isLoading);
    const onAccept = () => {
      if (id) {
        acceptChangeReq.mutate({ id, status: 'accepted' });
      }
      setId(null);
      setOpenUserRequestModal(false);
      setOpenUserRejectRequestModal(false);
      refetch();
    };
    const handelCloseView = () => {
      setId(null);
      setOpenUserRequestModal(false);
      refetch();
    };
    const handelCloseReject = () => {
      setId(null);
      setOpenUserRejectRequestModal(false);
      refetch();
    };
    return (
      <>
        <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
          <Paper className={classes.paper} elevation={3}>
            <Grid container justify='space-between' alignItems='center'>
              <p className={classes.label}>User View</p>
              <IconButton
                style={{ marginRight: -16 }}
                onClick={() => {
                  setId(null);
                  handleClose();
                  refetch();
                }}
              >
                <CloseIcon color='primary' />
              </IconButton>
            </Grid>
            <div>
              <div className={classes.table}>
                <Grid container justify='space-between' alignItems='center'>
                  <div className={classes.title}> Old Existing Profile Information</div>
                  <div className={classes.title}>New Updated Profile Information</div>
                </Grid>
              </div>
              <div className={classes.table}></div>
              <div className={classes.table}>
                <Grid container justify='space-between' alignItems='center'>
                  <div></div>
                  <div>
                    <span
                      onClick={() => {
                        handleClose();
                        setOpenUserRequestModal(true);
                      }}
                      className={classes.link}
                    >
                      Edit
                    </span>
                    <span onClick={onAccept} className={classes.link}>
                      Accept
                    </span>
                    <span
                      onClick={() => {
                        // onReject
                        handleClose();
                        setOpenUserRejectRequestModal(true);
                      }}
                      className={classes.link}
                    >
                      Reject
                    </span>
                  </div>
                </Grid>
              </div>
            </div>
          </Paper>
        </Modal>
        {openUserRequestModal && (
          <UserEditRequestForm
            defaultValue=''
            label=''
            open={openUserRequestModal}
            refetch={() => getUserChangeReq.refetch()}
            handleClose={handelCloseView}
            id={id}
            setId={setId}
            payload={undefined}
          />
        )}
        {openUserRejectRequestModal && (
          <UserRejectRequestForm
            defaultValue=''
            label=''
            open={openUserRejectRequestModal}
            refetch={() => getUserChangeReq.refetch()}
            handleClose={handelCloseReject}
            id={id}
            setId={setId}
            payload={undefined}
          />
        )}
      </>
    );
  }
);
